// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductDetailsPage_root__PrhMM"};